import { parseCIDR } from 'ipaddr.js';

export const getEnv = () => {
  try {
    const { origin, port, host } = window.location;
    //  if(port && origin.indexOf(':')){
    //    return 'dev'
    //  }
    if (origin.indexOf('cpgroupcloud') > -1) {
    //  非上市的
      if (origin.indexOf('dev') > -1 && !port) {
        return 'test';
      }
      if (origin.indexOf('dev') === -1 && !port && host.indexOf(':') === -1) {
        return 'pro';
      } else {
        return 'dev';
      }
    }
    if (origin.indexOf('cpcti') > -1) {
      //  上市的
      if (origin.indexOf('dev') > -1 && !port) {
        return 'test1';
      }
      if (origin.indexOf('dev') === -1 && !port && host.indexOf(':') === -1) {
        return 'pro1';
      } else {
        return 'dev1';
      }
    }
    return 'dev'
  } catch {
    return 'dev';
  }
};

export const ENV = getEnv();
console.log(ENV);

// 域名迁移。上市和不上市要分开。域名要改。
const paths = {
  // 没上市
  dev: {
    ROOT_PATH: 'https://gateway-dev.cpgroupcloud.com',
    IORDER_PATH: 'https://gateway-iorder-dev.cpgroupcloud.com'
  },
  test: {
    ROOT_PATH: 'https://gateway-dev.cpgroupcloud.com',
    IORDER_PATH: 'https://gateway-iorder-dev.cpgroupcloud.com'
  },
  pro: {
    ROOT_PATH: 'https://gateway.cpgroupcloud.com',
    IORDER_PATH: 'https://gateway-iorder.cpgroupcloud.com'
  },
  //上市的。
  dev1: {
    ROOT_PATH: 'https://gateway-dev.cpcti.com',
    IORDER_PATH: 'https://gateway-iorder-dev.cpcti.com'
  },
  test1: {
    ROOT_PATH: 'https://gateway-dev.cpcti.com',
    IORDER_PATH: 'https://gateway-iorder-dev.cpcti.com'
  },
  // 正式环境 2021-3-20后才使用新域名。
  pro1: {
    ROOT_PATH: 'https://gateway.cpcti.com',
    IORDER_PATH: 'https://gateway-iorder.cpcti.com'
  }
};
export const ROOT_PATH = paths[ENV].ROOT_PATH;
export const IORDER_PATH = paths[ENV].IORDER_PATH;

console.log('环境：',ENV, ROOT_PATH);
// 自动跳转时间
export const JUMPTIME = 3001;
